import { SocialProfileUrl } from '@/reports/sections/SocialMediaSection/SocialProfileUrl';
import {
  BaseReportOverview,
  SharedOverviewProps,
} from '@/reports/shared/ReportOverview/BaseReportOverview';
import { Box, Text } from '@/theme/index';

export interface UsernameOverviewProps extends SharedOverviewProps {
  username: string;
}

/**
 * An overview list that displays the username report name, the high
 * confidence toggle, and a few suggestions the user can do.
 */
export const UsernameOverview = ({
  reportType,
  username,
  showHighConfidenceToggle,
  showHighConfidenceDataOnly,
  setShowHighConfidenceDataOnly,
}: UsernameOverviewProps) => {
  const parsedUserName = new SocialProfileUrl(username);

  // Overview props
  const title = parsedUserName.getUsername() || '';
  const Tips = (
    <Box>
      <Text variant="body1">
        Click "Search Person" button for a full report
      </Text>
      <Text variant="body1">
        Click specific platform to view a person's social profile
      </Text>
    </Box>
  );

  return (
    <BaseReportOverview
      reportType={reportType}
      title={title}
      Tips={Tips}
      titleProps={{ sx: { fontSize: '2.125rem' } }}
      showHighConfidenceToggle={showHighConfidenceToggle}
      showHighConfidenceDataOnly={showHighConfidenceDataOnly}
      setShowHighConfidenceDataOnly={setShowHighConfidenceDataOnly}
    />
  );
};
